<template>
  <div>
    <section class="center">
      <img width="60" height="60" src="../assets/img/checkmark.png" alt="" />
      <p>Pass added successfully.</p>
      <div @click="handleOpenWallet">
        <IOSWalletButton @click="handleOpenWallet" />
      </div>
    </section>

    <p>
      After adding the passport, please open the wallet App on your smartphone.
      There you will find your saved Pass.
    </p>
    <p>
      <span>Select the appropriate passport and press the symbol</span>
      &nbsp;
      <span>
        <img
          src="../assets/img/edit-icon.png"
          alt=""
          height="14"
          style="display: inline-block;"
        />
      </span>
      &nbsp;
      <span>to access the settings and other information.</span>
    </p>

    <Button label="Open the wallet app" v-on:click="handleOpenWallet" />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import IOSWalletButton from "@/components/IOSWalletButton.vue";

export default {
  components: {
    Button,
    IOSWalletButton
  },
  mounted(context) {
    // TODO - add loading until pkpass is fetched
    this.$store.commit("loading", true);
    const pk = `${process.env.VUE_APP_YOURPASS_GET}/${this.$route.params.id}?format=pkpass`;

    // prepare directDownload link
    var pl = document.createElement("a");
    pl.href = pk;

    // fake a click on the link
    var me = document.createEvent("MouseEvents");
    me.initEvent("click", true, true);
    pl.dispatchEvent(me);

    setTimeout(() => {
      this.$store.commit("loading", false);
    }, 2000);
  },
  methods: {
    handleOpenWallet() {
      window.open("shoebox://");
    }
  }
};
</script>

<style scoped>
.center-img {
  margin: 0 auto;
}

.center {
  text-align: center;
}
</style>
